import {BookmarkIcon, House, MegaphoneIcon} from 'lucide-react';

export const useMainNavigation = (workspaceBaseUrl: string) => {
  return [
    {
      title: 'Dashboard',
      url: `${workspaceBaseUrl}/dashboard`,
      icon: House,
    },
    {
      title: 'Audiences',
      url: `${workspaceBaseUrl}/audiences`,
      icon: BookmarkIcon,
    },
    {
      title: 'Campaigns',
      url: `${workspaceBaseUrl}/campaigns`,
      icon: MegaphoneIcon,
    }
  ];
};
